import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

import { useDidMount } from '../hooks';

// Local Typings
interface Props {
  endScale?: number;
  startScale?: number;
  transitionSpeedInMs?: number;
}

// Local Variables
const growClassName = 'grow-is-in';
const Wrapper = styled.div<Props>(({
  transitionSpeedInMs = 300,
  ...props
}) => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '@media (prefers-reduced-motion)': {
    transform: 'none',

    [`&.${growClassName}`]: {
      transform: 'none',
    },
  },
  [`&.${growClassName}`]: {
    transform: `scale(${props.endScale})`,
  },
  transform: `scale(${props.startScale})`,
  transition: `${transitionSpeedInMs}ms`,
}));

// Component Definition
const Grow: FC<PropsWithChildren<Props>> = ({
  children,
  endScale = 1,
  startScale = 0,
  transitionSpeedInMs,
}) => {
  const didMount = useDidMount();

  return (
    <Wrapper
      className={didMount ? growClassName : undefined}
      endScale={endScale}
      startScale={startScale}
      transitionSpeedInMs={transitionSpeedInMs}
    >
      {children}
    </Wrapper>
  );
};

export default Grow;
